import axios from "axios";
import { BASE_URL } from "../../Config/BaseUrl";
const token = localStorage.getItem("token");

const createAxiosConfig = (url, method, data) => {
  return {
    method,
    url: `${BASE_URL}${url}/`,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    data,
  };
};


export const EssDasbaord = {
   Dashboard_ESS: async (data) => {
      var axiosConfig = createAxiosConfig("Dashboard_ESS", "POST", data);
      return await axios(axiosConfig);
    },
     my_attendance_overview_ESS: async (data) => {
      var axiosConfig = createAxiosConfig("my_attendance_overview_ESS", "POST", data);
      return await axios(axiosConfig);
    },
}